import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import BootstrapTable from "react-bootstrap-table-next";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../_metronic/_helpers";
import { useSubheader } from "../../_metronic/layout";
import { Link, useHistory } from "react-router-dom";
import { baseURLV1 } from "../service/API.js";
import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";
import paginationFactory from "react-bootstrap-table2-paginator";
import Pagination2 from "@material-ui/lab/Pagination";
import { useSelector } from "react-redux";


export const Notification = () => {
  const suhbeader = useSubheader();
  const allData = [];
  const [lisData, setListData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalSize, setTotalSize] = useState(100);
  const [openImage, setOpenImage] = useState(false)
  const [imgSelect, setImgSelect] = useState('')
  const [rotation, setRotation] = useState(0)
  const [id, setId] = useState('')
  const [relate_product_check, setRelateProductCheck] = useState(false)

  suhbeader.setTitle("Notification Management");
  const { authToken, accessTokenPrivilege } = useSelector((state) => state.auth);

  const history = useHistory();
  useEffect(() => {
    localStorage.removeItem('limitPage')
    localStorage.removeItem('checkPage')
    getData(1, 10, search);
  }, []);

  const getData = async (page, limit, search) => {
    setPage(page);
    axios({
      method: "get",
      url: `${baseURLV1}/pushNotification?page=${page}&limit=${limit}${search !== undefined && search !== "" ? "&search=" + search : ""
        }`,
       headers: {
         Accept: "application/json",
         Authorization: `Bearer ${authToken}`,
       },
    }).then((res) => {
      let allData = res.data.data
      if (res.message) {
        //history.push("/logout");
      } else {
        
        // allData.map((data, index) => {
        // })
      }

      var totalpage = Math.ceil(res.data.total / res.data.limit);
      setTotalPage(totalpage);
      setTotalSize(res.data.total);
      setLimit(res.data.limit);
      setListData(res.data.data);
      // console.log(res.data.data)
    });
  };
  
  const convertDate = ( date, formatDate) => {
    const dates = new Date(date)
    const result = dates.toLocaleDateString(formatDate, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    })

    return result
  }

  const columns = [
    {
      dataField: "title_th",
      text: "ชื่อแคมเปญพิเศษ",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
            <div style={{width:'120px'}}>
                <p>{row.title_th}</p>
            </div>
        );
      },
    },
    {
      dataField: "message_th",
      text: "รายละเอียด",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
            <div style={{width:'120px'}}>
                <p>{row.message_th}</p>
            </div>
        );
      },
    },
    {
      dataField: "group_condition_id",
      text: "กลุ่มเป้าหมาย",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
            <div style={{width:'120px'}}>
                <p>{row.group_condition_id ? row.group_condition_id : '-'}</p>
            </div>
        );
      },
    },
    {
      dataField: "push_date",
      text: "วันที่เริ่มแคมเปญ",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
            <div style={{width:'150px'}}>
                <p>{row.push_date ? convertDate(row.push_date, 'th-TH') : '-'}</p>
            </div>
        );
      },
    },
    {
      text: "Action",
      dataField: "id",
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{width:'140px'}}>
            <button
              type="button"
              className="btn btn-primary mr-2"
              onClick={() => editItem({ id, row, rowIndex })}
            >
              Edit
            </button>

            <button
              type="button"
              className="btn btn-primary"
              onClick={() => deleteItem({ row, rowIndex })}
            >
              Delete
            </button>

          </div>
        );
      },
    },
  ];

  const rotate = () => {
    let newRotation = Number(rotation) + 90
    if (newRotation >= 360) {
      newRotation = -360
    }
    setRotation(newRotation)
  }


  const editItem = (data) => {
    history.push("/EditNotification", data);
  };

  const deleteItem = (data) => {
    console.log(data)
    Swal.fire({
      title: "ยืนยันการลบรายการ?",
      text: "รายการนี้จะถูกลบออก !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "ลบ!",
      cancelButtonText: "ไม่ลบ",
    }).then((result) => {
      if (result.value) {
        axios
          .delete(`${baseURLV1}/pushNotification/${data.row.id}`)
          .then((res) => {
            Swal.fire("ทำรายการสำเร็จ!", "", "success");
            getData(1, limit, search);
          })
          .catch((err) => {
            Swal.fire(
              "ทำรายการไม่สำเร็จ!",
              "",
              "error"
            );
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("ยกเลิกการทำรายการ", "", "error");
      }
    });
  };
  const [search, setSearch] = useState();
  const handleSearch = () => {
    setPage(1);
    getData(1, limit, search);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    getData(value, limit, search);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    getData(1, event.target.value, search);
  };

  const handleClose = () => {
    setId('')
    setOpenImage(false)
    setImgSelect('')
    setRelateProductCheck(false)
  }

  return (
    <Card>
      <CardHeader title="Notification Management">
        <CardHeaderToolbar>
          <Link to="/CreateNotification">
            <button type="button" className="btn btn-primary">
              + Create
            </button>
          </Link>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        {/* <div className="row form-inline mb-2">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="Text Search"
                style={{ width: "100%" }}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <div className="form-group">
              <button
                type="button"
                id="button"
                className="btn btn-primary"
                style={{ width: "100%" }}
                onClick={() => handleSearch()}
              >
                Search
              </button>
            </div>
          </div>
        </div> */}

        <BootstrapTable
          keyField="id"
          data={lisData}
          columns={columns}
          wrapperClasses="table-responsive table-cm"
          bordered={false}
          classes="header-table table table-head-custom table-vertical-center overflow-hidden table-fixed"
          bootstrap4
        />
        <div className=" col-lg-12">
          <div className="row">
            <div className="col-lg-6 d-flex align-items-center">
              <div className="mt-3">
                {"Items per Page: "}
                <select onChange={handlePageSizeChange} value={limit}>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>
              <span class="mt-3 ml-5">Result : {totalSize} records</span>
            </div>
            <div className="col-lg-6">
              <Pagination2
                className="mt-3 "
                count={totalPage}
                page={page}
                siblingCount={1}
                boundaryCount={1}
                variant="outlined"
                shape="rounded"
                onChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
